import { useState } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import 'firebase/database';

const handleInputChange = setValues => e => {
    e.preventDefault();
    e.persist();

    setValues(values => ({ ...values, [e.target.name]: e.target.value }));
}

const submitForm = (setFinished, setError, setLoading, setUser, tempUser, values) => e => {
    e.preventDefault();

    const sendInvitationEmail = firebase
        .functions()
        .httpsCallable('sendInvitationEmail');

    setLoading(true);

    // create user in firebase
    const createUser = (!tempUser || tempUser.email !== values.email)
        ? firebase.auth().createUserWithEmailAndPassword(values.email, '123456')
            .then(({ user }) => {
                setUser(user);

                return user;
            })
        : Promise.resolve(tempUser);

    // update phone number and display name for user
    // and send the verification email
    createUser
        .then(user => {
            return firebase.database()
                .ref(`users/${user.uid}`)
                .set({
                    phone: values.phone,
                }).then(() => user.updateProfile({ 
                    displayName: `${values.firstname} ${values.lastname}`
                }))
                .then(() => user)
        })
        .then(({ email, displayName }) => sendInvitationEmail({
            recipient: email,
            displayName,
        }))
        .then(() => setFinished(true))
        .catch(error => {
            setError(error);
            setLoading(false);
        });    
}

function RegisterContainer({ render }) {
    const [finished, setFinished] = useState(false);
    const [error, setError] = useState(null);
    const [values, setValues] = useState({});
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(null);

    return render({
        finished,
        error,
        loading,
        handleInputChange: handleInputChange(setValues),
        submitForm: submitForm(setFinished, setError, setLoading, setUser, user, values),
    })
}

export default RegisterContainer;
